import { TermsOfService } from "@/components/common/TermsOfService";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/fr/termsOfServiceLUX')({
  component: () => TermsOfService({ pdfPath: '/TOS_SGLUX_FR.pdf' }),
})